import i18n from "../../i18n";
import { SET_ALERT, SET_SIDEBAR, SET_PAGE_TITLE, SET_LANGUAGE } from "./constants";

export const setAlert = value => ({ type: SET_ALERT, payload: value })

export const setSideBar = value => ({ type: SET_SIDEBAR, payload: value })

export const setPageTitle = value => ({ type: SET_PAGE_TITLE, payload: value })

export const setLanguage = (value) => {
    i18n.changeLanguage(value); // 🔥 Update i18next language
    localStorage.setItem("i18nextLng", value); // Save preference
    return { type: SET_LANGUAGE, payload: value }
}